import React, { useState, useEffect, useCallback } from "react";
import { getRequestInAssets as getRequestOnEnterprise } from "services/axiosAssetsBaseClient";
import { getRequest as getRequestOnEnterpriseClient } from "services/axiosBaseClient";
import TableAndSearch from "../common/TableAndSearch";
import { useHistory } from "react-router-dom";
import NotificationManager from "react-notifications/lib/NotificationManager";
import LocalStorageService from "services/tokenlocalstorage.service";
import { typeOf } from "react-is";

var tableSearchKey;
var tempSearch;

export default function Asset(props) {
  const { headerFilterParms, headerFilter } = props;

  const history = useHistory();

  const [zoneData, setZoneData] = useState([]);
  const [siteStatus, setSiteStatus] = useState(true);
  const [specialCharacters, setspecialCharacters] = useState(false);
  const [zoneHeader, setZoneHeader] = useState([headerFilterParms]);
  const [zoneHeaderFilterData, setZoneHeaderFilterData] = useState([]);
  const [activepageCount, setActivePageCount] = useState(0);
  const [tempSwap, setTempSwap] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const paginationCountHanlde = (count) => {
    setActivePageCount(count);
  };

  const zoneHeaderFilterHandle = (searchString) => {
    if (
      typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
    ) {
    } else {
      localStorage.setItem("lastTableSearch", searchString);
    }

    const headerFilterObj = JSON.parse(LocalStorageService.get("queryHeader"));

    console.log(headerFilterObj, "MAIN fn headerFilterObj");
    var query =
      (headerFilterObj?.enterprise
        ? "enterprise=" + headerFilterObj.enterprise
        : "") +
      (typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
        ? ""
        : "&name=" + encodeURIComponent(searchString));
    query = query ? "?" + query : "";

    console.log(query, "final QUEARTTyy");

    try {
      getRequestOnEnterpriseClient("model/get" + query)
        .then((resp) => {
          // getRequestOnEnterprise(`zone/getZoneInfo?enterprise=${headerFilterParms.enterprise}`).then((resp) => {
          if (resp && resp.data) {
            // const test = resp?.data?.zoneList;
            // setZoneHeaderFilterData(resp?.data?.zoneList);
            props.assetCount(() =>
              resp.data.count ? resp.data.count : resp?.data.length
            );
            // props.assetCount(() => resp?.data?.zoneList.length);
            setTotalCount(resp?.data.length);
            zoneListDataSortHandle(resp?.data);
            tableSearchKey = "";
          } else {
            props.assetCount(0);
            zoneListDataSortHandle([]);
          }
        })
        .catch((e) => {
          console.log(e, "ERROR");
          props.assetCount(0);
          zoneListDataSortHandle([]);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    setZoneHeaderFilterData([]);
    zoneHeaderFilterHandle(tempSearch.trim());
  }, [headerFilter]);

  const zoneListDataSortHandle = (data) => {
    var newZone = [];
    var oldZone = [];
    data.map((zone) => {
      if (zone.commissionedOn == null) {
        oldZone.push(zone);
      } else {
        newZone.push(zone);
      }
    });
    startSortingHandle(newZone, oldZone);
  };
  const startSortingHandle = (newZone, oldZone) => {
    const sortedData = newZone.sort(function (a, b) {
      var dateA = new Date(a.commissionedOn);
      var dateB = new Date(b.commissionedOn);
      return dateB - dateA;
    });
    mergingOldNewZone(sortedData, oldZone);
  };
  const mergingOldNewZone = (sortedData, oldZone) => {
    if (oldZone !== null) {
      for (let i of oldZone) {
        sortedData.push(i);
      }
    }

    setZoneHeaderFilterData(sortedData);
    // headerFilter
    //   ? setZoneHeaderFilterData(sortedData)
    //   : setZoneData(sortedData);
    // headerFilter =  false;
  };

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    if (tempSearch === null) {
      tempSearch = localStorage.setItem("lastTableSearch", "");
      zoneHeaderFilterHandle();
    } else {
      zoneHeaderFilterHandle(tempSearch.trim());
    }

    //  setSearchValue(localStorage.getItem("lastTableSearch"));
  }, []);

  const view = (id, enterprise) => {
    history.push("/Assets/viewModel/" + id + "/view");
  };

  const update = (id, enterpriseName) => {
    history.push("/Assets/updateModel/" + id);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Enterprise Name",
        accessor: "enterprise",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Type",
        accessor: "type",
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: (row) => {
          return (
            <div>
              {row.row?.original?.description ? (
                row.row?.original?.description
              ) : (
                <span>NA</span>
              )}
            </div>
          );
        },
      },
      // {
      //   Header: "Status",
      //   accessor: "isActive",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         {row.row.original.isActive ? (
      //           <p
      //             style={{
      //               display: "flex",
      //               justifyContent: "center",
      //               cursor: "default",
      //               background: "#1A873C",
      //               border: "1px",
      //               width: "80px",
      //               color: "#fff",
      //               borderRadius: "5px",
      //               margin: "3px 0px 2px 2px",
      //               padding: "3px 0px",
      //             }}
      //           >
      //             <span style={{ margin: "0px" }}>Active</span>
      //           </p>
      //         ) : (
      //           <p
      //             style={{
      //               display: "flex",
      //               justifyContent: "center",
      //               cursor: "default",
      //               background: "#C71720",
      //               border: "1px",
      //               width: "80px",
      //               color: "#fff",
      //               borderRadius: "5px",
      //               margin: "3px 0px 2px 2px",
      //               padding: "3px 0px",
      //             }}
      //           >
      //             <span style={{ margin: "0px" }}>Inactive</span>
      //           </p>
      //         )}
      //       </>
      //     );
      //   },
      //   // row.status ? row.status : "Active",
      // },
      {
        Header: "Action",
        accessor: "id",
        disableSortBy: true,
        Cell: (row) => {
          return (
            <>
              <div>
                <img
                  src={require("assets/eye.png").default}
                  style={{ margin: "8px", cursor: "pointer" }}
                  onClick={() => view(row.value, row.row.original.enterprise)}
                ></img>
                <img
                  src={require("assets/pencil.png").default}
                  style={{ cursor: "pointer" }}
                  onClick={() => update(row.value, row.row.original.enterprise)}
                ></img>
                {/* {row.row.original.isActive ? (
                  <button
                    onClick={() =>
                      siteStatusHandle(
                        row,
                        "active",
                        row.row.original.enterpriseName
                      )
                    }
                    style={{ border: "none", margin: "8px", cursor: "pointer" }}
                  >
                    <img
                      src={require("assets/active.png").default}
                      height={"20px"}
                      width={"20px"}
                    ></img>
                  </button>
                ) : (
                  <button
                    onClick={() =>
                      siteStatusHandle(
                        row,
                        "inactive",
                        row.row.original.enterpriseName
                      )
                    }
                    style={{ border: "none", margin: "8px", cursor: "pointer" }}
                  >
                    <img
                      src={require("assets/inactive.png").default}
                      height={"20px"}
                      width={"20px"}

                      // onClick={() =>
                      //   view(row.value, row.row.original.enterprise)
                      // }
                    ></img>
                  </button>
                )} */}
              </div>
            </>
          );
        },
      },
    ],
    [setTempSwap, tempSwap, zoneHeaderFilterData]
  );

  return (
    <div>
      <TableAndSearch
        totalCount={totalCount}
        activepageCount={activepageCount}
        paginationCountHanlde={paginationCountHanlde}
        searchOpts={{
          onSearch: zoneHeaderFilterHandle,
          placeholder: "Search By Model Name",
        }}
        specialCharacters={specialCharacters}
        columns={columns}
        data={zoneHeaderFilterData}
        tigger={props?.tigger}
        tabTemp={props.tabTemp}
        tempSearch={tempSearch}
        headerFilterParms={props?.headerFilterParms}
      />
    </div>
  );
}
